import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5dcebe02"
import script from "./detail.ts?vue&type=script&lang=ts&external"
export * from "./detail.ts?vue&type=script&lang=ts&external"
import style0 from "./detail.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports